module.exports = __webpack_public_path__ + "static/media/dexToolse.427f99a9.png";